import { ExperimentMap } from '@glossgenius/core-features-react-sdk';

/**
 * Every experiment MUST have a CONTROL variant.
 * This is the default variation that will be used
 * if we fail to fetch the assignment from the server
 * or the user is not in the experiment.
 * Docs: https://www.notion.so/glossgeniusteam/Running-In-Product-Experiments-with-Eppo-39fb56571bde4a15a1013125cbef518c
 * FYI: The word "control" comes from scientific experiments in general.
 * https://www.indeed.com/career-advice/career-development/what-is-a-control-in-an-experiment#:~:text=When%20conducting%20an%20experiment%2C%20a,cosmetic%20testing%20and%20medication%20testing.
 */
export const EXPERIMENTS: ExperimentMap = {
  AA_TEST: {
    // https://eppo.cloud/feature-flags/88044/targeting/RW52aXJvbm1lbnQ6NDEy
    key: 'experiment-en-20787-cwpa-aa-test',
    variations: {
      CONTROL: 'control',
      VARIANT: 'variant',
    },
  },
};
